import React, { FC, useId, useRef } from 'react';
import { ModalDialog } from 'components/ModalDialog/ModalDialog';
import SVGInline from 'components/SVGInline/SVGInline';
import { useBackdropClose } from 'hooks/useBackdropClose/useBackdropClose';
import Button from 'components/Buttons/Button/Button';
import { withNoScroll } from '../../hooks/withNoScroll/withNoScroll';
import icons from '../../style';
import { ModalNavigation, ModalCloseButton, ModalWrapper } from '../../style/styled-components/reusable.css';
import translate from '../../utils/fnTranslate';
import { MessageContent, ChannelLogo, ChannelTitle, MessageText, ButtonRow } from './UpsellMessageSelector.css';

type PropTypes = {
    channelLogo?: string;
    channelName?: string;
    onContinue: () => void;
    onClose: () => void;
};

const UpsellMessage: FC<PropTypes> = ({ channelLogo, channelName, onContinue, onClose }) => {
    const titleId = useId();
    const descriptionId = useId();
    const continueButtonRef = useRef<HTMLButtonElement>(null);
    const backdropClose = useBackdropClose(onClose);

    const renderMessageContent = () => (
        <MessageContent {...backdropClose}>
            {channelLogo && <ChannelLogo src={channelLogo} alt="" />}
            <ChannelTitle id={titleId}>{channelName}</ChannelTitle>
            <MessageText id={descriptionId}>{translate('CHANNEL_UPSELL_TEXT')}</MessageText>
            <ButtonRow>
                <Button label={translate('BACK_BUTTON')} onClick={onClose} tabIndexOverride={0} />
                <Button
                    label={translate('SCREEN_UPSELL_TITLE')}
                    ref={continueButtonRef}
                    onClick={onContinue}
                    isPrimary
                    tabIndexOverride={0}
                />
            </ButtonRow>
        </MessageContent>
    );

    return (
        <ModalDialog
            as={ModalWrapper}
            onClose={onClose}
            initialFocusRef={continueButtonRef}
            opacity={1}
            aria-labelledby={titleId}
            aria-describedby={descriptionId}
            {...backdropClose}
        >
            <ModalNavigation {...backdropClose}>
                <ModalCloseButton type="button" onClick={onClose} tabIndex={0} aria-label={translate('CLOSE_BUTTON')}>
                    <SVGInline svg={icons.closeIcon} />
                </ModalCloseButton>
            </ModalNavigation>
            {renderMessageContent()}
        </ModalDialog>
    );
};

export const UpsellMessageScreen = withNoScroll(UpsellMessage);
